import { initials } from '@/lib/format';
import styles from './Cover.module.css';

interface CoverProps {
  title: string;
  /** Cover art thumbnail (data URL); without it, the title's initials are shown. */
  src?: string | undefined;
  size: number;
  tone?: 'accent' | 'success';
}

/** Song cover: tag artwork, or an initials tile as a fallback (design: Library rows). */
export function Cover({ title, src, size, tone = 'accent' }: CoverProps) {
  const style = { width: size, height: size, fontSize: Math.round(size * 0.32) };
  if (src) return <img className={styles.cover} src={src} alt="" style={style} />;
  return (
    <span className={styles.cover} data-tone={tone} style={style} aria-hidden="true">
      {initials(title)}
    </span>
  );
}
